import { render, staticRenderFns } from "./sortList.vue?vue&type=template&id=ede4e34c&scoped=true&"
import script from "./sortList.vue?vue&type=script&lang=js&"
export * from "./sortList.vue?vue&type=script&lang=js&"
import style0 from "./sortList.vue?vue&type=style&index=0&id=ede4e34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede4e34c",
  null
  
)

export default component.exports